import { Component, OnInit, ViewChild, ElementRef, OnDestroy, inject } from '@angular/core';
import { StoreService } from 'src/app/services/store.service';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { decompress } from 'lz-string';
import { BehaviorSubject, combineLatest, concatMap, debounceTime, forkJoin, map, merge, Observable, Subject, take, takeUntil } from 'rxjs';
import { MatCheckbox } from '@angular/material/checkbox';
import { TextService } from 'src/app/services/text.service';
import { translateDateForSQLServer } from 'src/app/Utility/date_functions/SQL_ISO_adapter';
import { LoadingStatuses } from 'src/app/Interfaces/util';
import { BottomPopupService } from 'src/app/services/bottom-popup.service';

type DocType = {
	DocType: string;
	DocName: string;
};

const pathsToPage = {
	'b2b-to-agent': 'B2B',
	'b2b-only': 'B2BOnly',
	reclamation: 'reclamation',
	'brands-admin': 'brandsAdmin',
	brands: 'brands',
	'dohot-bizoim-azmanot': 'bizoimAzmanot',
	'teudot-for-confirm': 'teudotForConfirm',
} as const;

type PossiblePaths = keyof typeof pathsToPage;
type PageMode = typeof pathsToPage[PossiblePaths];

@Component({
	selector: 'app-dohot-bizoim-azmanot',
	templateUrl: './dohot-bizoim-azmanot.component.html',
	styleUrls: ['./dohot-bizoim-azmanot.component.scss'],
})
export class DohotBizoimAzmanotComponent implements OnInit, OnDestroy {
	_ss = inject(StoreService);
	_fb = inject(FormBuilder);
	_text = inject(TextService);
	router = inject(Router);
	private _bottomPopup = inject(BottomPopupService);
	constructor() {}

	public form = this._fb.group({
		Search: [''],
		from: [<Date>null],
		to: [<Date>null],
	});
	public AllOrdersBitzoimPerAgent;
	public AllOrdersBitzoimPerAgentSave;
	public Each = false;
	public Main = true;
	public TotalArrayChecked = 0;
	public TotalArray = 0;
	public ArrayChecked = [];
	public ShowCompanys = null;
	public HasMultipleCompanys;

	companyDictionary = {};

	LoadingSeeTeuda = false;
	SeeTeudaLoaded = false;

	loadingChangeStatusTeuda = false;

	selectedTeudaToOpenPopup = null;
	selectedTeudaNum = null;

	destroy$: Subject<void> = new Subject();

	monthArrWithExistingMonths = new Array(12);

	showFilterPopup = false;

	remarks = [];

	pageMode$ = new BehaviorSubject<PageMode>(this.getInitialPageMode());

	isNotReclamation$ = this.pageMode$.pipe(map(page => page !== 'reclamation'));
	isRemarkPopupOpen = false;
	isNotTeudotForConfirm$ = this.pageMode$.pipe(map(page => page !== 'teudotForConfirm'));
	isTeudotForConfirm$ = this.pageMode$.pipe(map(page => page === 'teudotForConfirm'));
	shouldSearchBarBeVisible$ = this.isNotTeudotForConfirm$.pipe(map(Boolean));
	shouldShowFilterAndTotalRow$ = combineLatest([this.isNotReclamation$, this.isNotTeudotForConfirm$]).pipe(
		map(([isNotReclamation, isNotTeudotForConfirm]) => isNotReclamation && isNotTeudotForConfirm),
	);

	selectedTeudaNumForConfirm$ = new BehaviorSubject<{ TeudaNum: string; TeudaNewNum: string; action?: 'delete' | 'confirm' }>({ TeudaNum: '', TeudaNewNum: '' });
	teudaForConfirmLoadingState$ = new BehaviorSubject<LoadingStatuses>('idle');
	hasUserChangeColumnInTeudaSQLTable = false;

	title$ = this.pageMode$.pipe(map(this.getPageTitle));

	lastColumnTitle$ = this.pageMode$.pipe(map(this.getLastColumnTitle));

	docTypes;
	docTypesControl = new FormControl<Array<DocType>>([], { nonNullable: true });
	docTypeHash: { [key: number]: string } = {};

	checkedObject: { [key: string]: boolean } = {};

	datesFilter = [];

	canSeePrices = true;

	selectedTeudaTotals = {
		TeudaQuantity: 0,
		TeudaPackQuantity: 0,
		TeudaBonusQuantity: 0,
		TeudaPrice: 0,
		TeudaItemDiscount: 0,
		TeudaItemNetPrice: 0,
		TeudaTotalRow: 0,
		TeudaItemProfit: 0,
	};
	selectedTeudaTotalsArray = ['סה"כ', '', 'TeudaQuantity', 'TeudaPackQuantity', 'TeudaBonusQuantity', 'TeudaPrice', 'TeudaItemDiscount', 'TeudaItemNetPrice', 'TeudaTotalRow', ''];

	teudaConfirmCheckboxesFormArray = this._fb.array([]);
	canSubmitTeudaConfirm$ = this.teudaConfirmCheckboxesFormArray.valueChanges.pipe(map(checkboxes => checkboxes.some(Boolean)));

	ngOnInit(): void {
		console.clear();

		//////////////////// ---------- CLIENT INFORMATION ---------- ////////////////////
		if (this._ss.CustomerInformation === null) {
			if (localStorage.getItem('CustomerInformation') !== null) {
				this._ss.CustomerInformation = decompress(localStorage.getItem('CustomerInformation'));
				this._ss.CustomerInformation = JSON.parse(this._ss.CustomerInformation);
			}
		}
		//////////////////// ---------- CLIENT INFORMATION ---------- ////////////////////

		if (localStorage.getItem('UserName') !== null && localStorage.getItem('AgentId') !== null) {
			this._ss.UserNameConnected = localStorage.getItem('UserName');
			this._ss.AgentIdConnected = localStorage.getItem('AgentId');
		} else {
			this.router.navigate(['login']);
		}

		// TODO fix for companies missing parameter
		this.HasMultipleCompanys = localStorage.getItem('HasMultipleCompanys');

		if (this.HasMultipleCompanys === '2') {
			if (localStorage.getItem('ShowCompanys') !== null) {
				this.ShowCompanys = localStorage.getItem('ShowCompanys');
				this.ShowCompanys = JSON.parse(this.ShowCompanys);
				this.companyDictionary = this.ShowCompanys.reduce((acc, company) => {
					acc[company.CompanyId] = company.CompanyName;
					return acc;
				}, {});
			} else {
				this._ss.GetComppanys().subscribe(res => {
					this.ShowCompanys = res;
					this.ShowCompanys = this.ShowCompanys.recordset;
					localStorage.setItem('ShowCompanys', JSON.stringify(this.ShowCompanys));
					this.companyDictionary = this.ShowCompanys.reduce((acc, company) => {
						acc[company.CompanyId] = company.CompanyName;
						return acc;
					}, {});
				});
			}
		}

		if (this.pageMode$.value !== 'reclamation') {
			const docTypes = localStorage.getItem('AllDocTypesSave');

			if (docTypes) {
				this.docTypes = JSON.parse(decompress(docTypes));
			}
		}

		this.isTeudotForConfirm$.pipe(take(1)).subscribe(v => {
			if (v) this.selectedTeudaTotalsArray.unshift('');
		});

		this.resolveInitialDatabaseCall();

		window.scrollTo(0, 0);

		this.initiateSearchObservable();
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
		document.body.classList.remove('no-scroll');
	}

	public BackToDohotBizoim() {
		window.scrollTo(0, 0);
		if (this.Each === true || this.Last === true) {
			this.Main = true;
			this.Each = false;
			this.Last = false;
		} else {
			history.back();
		}
	}

	dateFilterFunction = (date: Date): boolean => {
		const dates = this.datesFilter;

		const actualDate = translateDateForSQLServer(date);

		return date ? dates.includes(actualDate.toISOString().slice(0, 10)) : false;
	};

	public ChooseDate() {
		if (!this.form.controls.from.value || !this.form.controls.to.value) return;

		this.ArrayChecked = [];
		this.TotalArrayChecked = 0;

		// const threeHours = 1000 * 60 * 60 * 3;

		this.AllOrdersBitzoimPerAgent = this.AllOrdersBitzoimPerAgentSave.filter(biz => {
			const teudaDate = new Date(biz.TeudaDate.slice(0, 10)).getTime();

			if (this.form.controls.from.value.toISOString().slice(0, 10) === this.form.controls.to.value.toISOString().slice(0, 10)) {
				return new Date(teudaDate).toISOString().slice(0, 10) === translateDateForSQLServer(this.form.controls.from.value).toISOString().slice(0, 10);
			}

			return (
				teudaDate >= new Date(translateDateForSQLServer(this.form.controls.from.value).toISOString().slice(0, 10)).getTime() &&
				teudaDate <= new Date(translateDateForSQLServer(this.form.controls.to.value).toISOString().slice(0, 10)).getTime()
			);
		});

		if (this.docTypesControl.value.length) {
			this.AllOrdersBitzoimPerAgent = this.AllOrdersBitzoimPerAgent.filter(order => {
				return this.docTypesControl.value.find(docType => docType.DocType === order.TeudaType);
			});
		}

		this.TotalArray = this.AllOrdersBitzoimPerAgent.reduce((prev, curr) => prev + +curr.TeudaTotalSum, 0);

		this.showFilterPopup = !this.showFilterPopup;
	}

	handleChangeDoctype(val) {
		if (val && val.length) {
			this.AllOrdersBitzoimPerAgent = this.AllOrdersBitzoimPerAgentSave.filter(order => {
				return val.find(docType => docType.DocType === order.TeudaType);
			});
		} else {
			this.AllOrdersBitzoimPerAgent = this.AllOrdersBitzoimPerAgentSave;
		}

		if (this.form.controls.from.value || this.form.controls.to.value) {
			const threeHours = 1000 * 60 * 60 * 3;

			this.AllOrdersBitzoimPerAgent = this.AllOrdersBitzoimPerAgent.filter(biz => {
				const teudaDate = new Date(biz.TeudaDate.slice(0, 10)).getTime();

				if (this.form.controls.from.value.toISOString().slice(0, 10) === this.form.controls.to.value.toISOString().slice(0, 10)) {
					return new Date(teudaDate).toISOString().slice(0, 10) === new Date(this.form.controls.from.value.getTime() + threeHours).toISOString().slice(0, 10);
				}

				return (
					teudaDate >= new Date(new Date(this.form.controls.from.value.getTime() + threeHours).toISOString().slice(0, 10)).getTime() &&
					teudaDate <= new Date(new Date(this.form.controls.to.value.getTime() + threeHours).toISOString().slice(0, 10)).getTime()
				);
			});
		}

		this.TotalArray = this.AllOrdersBitzoimPerAgent.reduce((prev, curr) => prev + +curr.TeudaTotalSum, 0);

		this.showFilterPopup = !this.showFilterPopup;
	}

	public OrderChecked(TeudaNum, TeudaTotalSum) {
		this.checkedObject[TeudaNum] = !this.checkedObject[TeudaNum];

		let data = this.ArrayChecked.find(ob => ob.TeudaNum === TeudaNum);

		if (data !== undefined) {
			this.ArrayChecked.splice(this.ArrayChecked.indexOf(this.ArrayChecked.find(ob => ob.TeudaNum === TeudaNum)), 1);

			this.TotalArrayChecked = 0;
			for (let x = 0; x < this.ArrayChecked.length; x++) {
				this.TotalArrayChecked += this.ArrayChecked[x].TeudaTotalSum;
			}
		} else {
			this.TotalArrayChecked = 0;

			this.ArrayChecked.push({ TeudaNum: TeudaNum, TeudaTotalSum: TeudaTotalSum });
			for (let x = 0; x < this.ArrayChecked.length; x++) {
				this.TotalArrayChecked += this.ArrayChecked[x].TeudaTotalSum;
			}
		}
	}

	SearchClear() {
		this.form.controls.Search.reset();
	}
	public Loading = false;
	public TeudotTableEach;
	public TeudotEach;
	public TeudotEachString;
	public Last = false;

	seeTeuda(TeudaNum, index, teudaNumDisplay) {
		document.body.classList.add('no-scroll');
		this.selectedTeudaToOpenPopup = this.AllOrdersBitzoimPerAgent[index];
		this.selectedTeudaNum = teudaNumDisplay;
		console.log(this.selectedTeudaToOpenPopup);
		this.LoadingSeeTeuda = true;

		this._ss.GetTeudotFirst(TeudaNum).subscribe(
			(res: any) => {
				this.TeudotTableEach = res.recordset;

				this.buildTotalTeuda(this.TeudotTableEach);

				setTimeout(async () => {
					if (!this.TeudotTableEach.length) {
						this._ss.GetTeudotEach(TeudaNum).subscribe(
							(res: any) => {
								this.TeudotEach = res.recordset;
								this.TeudotEachString = this.TeudotEach[0].DATAString;
								this.TeudotEach = JSON.parse(this.TeudotEach[0].DATAString);

								this.remarks = [
									this.TeudotEach[0].TeudaRemark1,
									this.TeudotEach[0].TeudaRemark2,
									this.TeudotEach[0].TeudaRemark3,
									this.TeudotEach[0].TeudaRemark4,
									this.TeudotEach[0].TeudaRemark5,
								].filter(r => r.length);

								console.log({ remarks: this.remarks, teuda: this.TeudotEach });

								if (this.TeudotEach[0].TeudaRemark) this.selectedTeudaToOpenPopup.remark = this.TeudotEach[0].TeudaRemark;

								this.buildTotalTeuda(this.TeudotEach);

								this.SeeTeudaLoaded = true;
								this.LoadingSeeTeuda = false;
							},
							err => {
								alert('שגיאת שרת, אנא נסו שנית');
								this.LoadingSeeTeuda = false;
								document.body.classList.remove('no-scroll');
								this.buildTotalTeuda([]);
							},
						);
					} else {
						this.SeeTeudaLoaded = true;
						this.LoadingSeeTeuda = false;

						if (this.TeudotTableEach[0].TeudaRemark) this.selectedTeudaToOpenPopup.remark = this.TeudotTableEach[0].TeudaRemark;

						// console.log(this.remarks);

						if (this.pageMode$.value === 'teudotForConfirm') {
							this._ss.GetTeudotEach(TeudaNum).subscribe({
								next: (res: any) => {
									if (!res.recordset) return;
									const teudot = JSON.parse(res.recordset[0].DATAString);
									console.log(teudot, this.TeudotTableEach);
									// return;
									for (const teuda of teudot) {
										const originalTeuda = this.TeudotTableEach.find(t => t.TeudaRef === teuda.TeudaNum && t.ProductId === teuda.ProductId);
										if (!originalTeuda) continue;
										originalTeuda.previousTeudaQuantity = teuda.TeudaQuantity;
										originalTeuda.previousTeudaPackQuantity = teuda.TeudaPackQuantity;
										originalTeuda.previousTeudaPrice = teuda.TeudaPrice;
										originalTeuda.previousTeudaBonusQuantity = teuda.TeudaBonusQuantity;
										originalTeuda.previousTeudaItemDiscount = teuda.TeudaItemDiscount;
										originalTeuda.previousTeudaItemNetPrice = teuda.TeudaItemNetPrice;
										originalTeuda.previousTeudaTotalRow = teuda.TeudaTotalRow;
										this.TeudotTableEach[this.TeudotTableEach.indexOf(originalTeuda)] = { ...originalTeuda };
									}
									this.TeudotTableEach = [...this.TeudotTableEach];
									console.log(this.TeudotTableEach);
								},
								error: () => {},
							});
						}
					}
				}, 200);
			},
			err => {
				alert('שגיאת שרת, אנא נסו שנית');
				this.LoadingSeeTeuda = false;
				document.body.classList.remove('no-scroll');
			},
		);
	}

	seeTeudaAgentForConfirm(teuda) {
		const { TeudaStatus, TeudaNewNum, TeudaNum } = teuda;

		document.body.classList.add('no-scroll');
		this.selectedTeudaToOpenPopup = teuda;
		this.selectedTeudaNum = TeudaNewNum;
		console.log(this.selectedTeudaToOpenPopup);
		this.LoadingSeeTeuda = true;

		this._ss.GetTeudotFirst({ TeudaNum, statuses: [2, 3] }).subscribe({
			next: res => {
				if (typeof res === 'string') {
					alert('שגיאת שרת, אנא נסו שנית');
					return;
				}

				this.TeudotTableEach = res.recordset;

				this.teudaConfirmCheckboxesFormArray.clear();

				for (const row of this.TeudotTableEach) {
					this.teudaConfirmCheckboxesFormArray.push(this._fb.control(false));
				}

				this.buildTotalTeuda(this.TeudotTableEach);

				setTimeout(async () => {
					if (!this.TeudotTableEach.length) {
						alert('שגיאת שרת, אנא נסו שנית');
						this.LoadingSeeTeuda = false;
						document.body.classList.remove('no-scroll');
						this.buildTotalTeuda([]);
						return;
					}

					this.SeeTeudaLoaded = true;
					this.LoadingSeeTeuda = false;

					if (this.TeudotTableEach[0].TeudaRemark) this.selectedTeudaToOpenPopup.remark = this.TeudotTableEach[0].TeudaRemark;

					this._ss.GetTeudotEach(TeudaNum).subscribe({
						next: (res: any) => {
							if (!res.recordset) return;
							const teudot = JSON.parse(res.recordset[0].DATAString);
							console.log(teudot, this.TeudotTableEach);

							for (const teuda of teudot) {
								const originalTeuda = this.TeudotTableEach.find(t => t.TeudaRef === teuda.TeudaNum && t.ProductId === teuda.ProductId && t.TeudaLineNum === teuda.TeudaLineNum);
								if (!originalTeuda) continue;
								originalTeuda.previousTeudaQuantity = teuda.TeudaQuantity;
								originalTeuda.previousTeudaPackQuantity = teuda.TeudaPackQuantity;
								originalTeuda.previousTeudaPrice = teuda.TeudaPrice;
								originalTeuda.previousTeudaBonusQuantity = teuda.TeudaBonusQuantity;
								originalTeuda.previousTeudaItemDiscount = teuda.TeudaItemDiscount;
								originalTeuda.previousTeudaItemNetPrice = teuda.TeudaItemNetPrice;
								originalTeuda.previousTeudaTotalRow = teuda.TeudaTotalRow;
								this.TeudotTableEach[this.TeudotTableEach.indexOf(originalTeuda)] = { ...originalTeuda };
							}
							this.TeudotTableEach = [...this.TeudotTableEach];
							console.log(this.TeudotTableEach);
						},
						error: () => {},
					});
				}, 200);
			},
			error: () => {
				alert('שגיאת שרת, אנא נסו שנית');
			},
		});
	}

	changeTeudaStatusToSix() {
		this.teudaForConfirmLoadingState$.next('loading');
		const TeudaStatus = 6;
		const TeudaNum = this.selectedTeudaNumForConfirm$.value.TeudaNewNum;
		const teudot = this.TeudotTableEach;
		const selectedRows = this.teudaConfirmCheckboxesFormArray.value.map((checked, i) => ({ checked, ...teudot[i] })).filter(row => row.checked);
		const body = {
			lines: selectedRows.map(row => ({ TeudaNum, TeudaLineNum: row.TeudaLineNum, TeudaStatus })),
		};
		if (this.hasUserChangeColumnInTeudaSQLTable) {
			for (const line of body.lines) {
				line['UserChange'] = this._ss.AgentIdConnected;
			}
		}
		this._ss.changeTeudaStatusToCustomStatus(body).subscribe({
			next: res => {
				if (typeof res === 'string') {
					alert('שגיאת שרת, אנא נסו שנית');
					this.teudaForConfirmLoadingState$.next('idle');
					return;
				}
				this.teudaForConfirmLoadingState$.next('idle');
				this._bottomPopup.show(`תעודה ${this.selectedTeudaNumForConfirm$.value.TeudaNewNum} בוטלה בהצלחה`);
				this.selectedTeudaNumForConfirm$.next(null);
				this.selectedTeudaNum = null;
				this.SeeTeudaLoaded = this.LoadingSeeTeuda = false;
				this.resolveInitialDatabaseCall();
			},
			error: err => {
				alert('שגיאת שרת, אנא נסו שנית');
				this.teudaForConfirmLoadingState$.next('idle');
			},
		});
	}

	handleClosePopup() {
		this.SeeTeudaLoaded = false;
		this.LoadingSeeTeuda = false;
		this.TeudotTableEach = [];
		this.selectedTeudaToOpenPopup = null;
		this.TeudotEach = [];
		this.remarks = [];
		document.body.classList.remove('no-scroll');
	}

	resetSort() {
		this.AllOrdersBitzoimPerAgent = this.AllOrdersBitzoimPerAgentSave;
		this.form.controls.from.reset();
		this.form.controls.to.reset();
		this.docTypesControl.setValue([]);
		this.showHideFilterPopup(false);

		this.SearchClear();
	}

	showHideFilterPopup(val: boolean): void {
		this.showFilterPopup = val;
	}

	initiateSearchObservable() {
		if (this.pageMode$.value === 'reclamation') {
			this.initiateReclamationSearchObservable();
			return;
		}
		this.form.controls.Search.valueChanges.pipe(debounceTime(150), takeUntil(this.destroy$)).subscribe(val => {
			this.ArrayChecked = [];
			this.TotalArrayChecked = 0;
			this.TotalArray = 0;

			this.form.controls.from.reset();
			this.form.controls.to.reset();
			this.docTypesControl.reset();

			if (val) {
				this.AllOrdersBitzoimPerAgent = this.AllOrdersBitzoimPerAgentSave.filter(td =>
					new RegExp(val.toLowerCase().replace(/[\/*\+\-\?,]/g, ''), 'g').test(
						('' + td.Client_Name + td.TeudaNum + td.TeudaNewNum + (td.TuedaErpDocNum || '')).toLowerCase().replace(/[\/*\+\-\?,]/g, ''),
					),
				);

				document.querySelectorAll('input[type="checkbox"]').forEach(chckbx => ((chckbx as HTMLInputElement).checked = false));

				this.checkedObject = {};

				for (let x = 0; x < this.AllOrdersBitzoimPerAgent.length; x++) {
					this.TotalArray += this.AllOrdersBitzoimPerAgent[x].TeudaTotalSum;
				}
				return;
			}

			this.AllOrdersBitzoimPerAgent = this.AllOrdersBitzoimPerAgentSave;

			for (let x = 0; x < this.AllOrdersBitzoimPerAgent.length; x++) {
				this.TotalArray += this.AllOrdersBitzoimPerAgent[x].TeudaTotalSum;
			}

			document.querySelectorAll('.mat-checkbox').forEach(chckbx => ((chckbx as any as MatCheckbox).checked ? (chckbx as any as MatCheckbox).toggle() : null));

			this.checkedObject = {};
		});
	}

	initiateReclamationSearchObservable() {
		this.form.controls.Search.valueChanges.pipe(debounceTime(150), takeUntil(this.destroy$)).subscribe(val => {
			if (val) {
				this.AllOrdersBitzoimPerAgent = this.AllOrdersBitzoimPerAgentSave.filter(td =>
					new RegExp(val.toLowerCase().replace(/[\/*\+\-\?,]/g, ''), 'g').test(('' + td.Client_Name + td.RekID).toLowerCase().replace(/[\/*\+\-\?,]/g, '')),
				);

				return;
			}

			this.AllOrdersBitzoimPerAgent = this.AllOrdersBitzoimPerAgentSave;
		});
	}

	handleMatchDoctypes() {
		const doctypeSet = new Set();

		for (let x = 0; x < this.AllOrdersBitzoimPerAgent.length; x++) {
			this.TotalArray += this.AllOrdersBitzoimPerAgent[x].TeudaTotalSum;

			doctypeSet.add(this.AllOrdersBitzoimPerAgent[x].TeudaType);

			if (this.AllOrdersBitzoimPerAgent[x].TeudaDate) {
				const monthOfOrder = new Date(this.AllOrdersBitzoimPerAgent[x].TeudaDate).getMonth();
				this.monthArrWithExistingMonths[monthOfOrder] = true;
			}
		}

		this.AllOrdersBitzoimPerAgentSave.sort((a, b) => new Date(b.TeudaDate).getTime() - new Date(a.TeudaDate).getTime());

		this.docTypes = Array.from(doctypeSet).map(type => {
			const doc = this.docTypes.find(docType => docType.DocType === type);
			if (doc) {
				return { DocName: doc.DocName, DocType: type };
			}
			return { DocName: type, DocType: type };
		});

		this.docTypeHash = this.docTypes.reduce((acc, docType) => {
			acc[docType.DocType] = docType.DocName;
			return acc;
		}, this.docTypeHash);
	}

	sendToConfirm(TeudaNum: string, TeudaNewNum: string) {
		this.teudaForConfirmLoadingState$.next('loading');

		const teudot = this.TeudotTableEach?.length ? this.TeudotTableEach : this.TeudotEach;

		const selectedRows = this.teudaConfirmCheckboxesFormArray.value.map((checked, i) => ({ checked, ...teudot[i] })).filter(row => row.checked);

		const body: { lines: Array<{ TeudaNum: string; TeudaLineNum: number; UserChange?: string }> } = {
			lines: selectedRows.map(row => ({ TeudaNum: row.TeudaNum, TeudaLineNum: row.TeudaLineNum })),
		};

		if (this.hasUserChangeColumnInTeudaSQLTable) {
			body.lines.forEach(line => {
				line.UserChange = this._ss.AgentIdConnected;
			});
		}

		this._ss.changeTeudotStatusToConfirmed(body).subscribe({
			next: res => {
				this.teudaForConfirmLoadingState$.next('idle');
				if (typeof res === 'string') {
					alert('לא ניתן לאשר תעודה זו, נסה שנית מאוחר יותר');
					return;
				}
				this._bottomPopup.show(`תעודה ${TeudaNewNum} אושרה בהצלחה`);
				this.selectedTeudaNumForConfirm$.next(null);
				this.selectedTeudaNum = null;
				this.SeeTeudaLoaded = this.LoadingSeeTeuda = false;
				this.resolveInitialDatabaseCall();
			},
			error: () => {
				alert('שגיאת שרת, נסה שנית מאוחר יותר');
				this.teudaForConfirmLoadingState$.next('idle');
			},
		});
	}

	closeTeudaNumForConfirm() {
		this.selectedTeudaNumForConfirm$.next({ TeudaNum: '', TeudaNewNum: '' });
	}

	resolveInitialDatabaseCall() {
		const callbackAfterSubscribing = (HTTPRequest: Observable<any>) =>
			HTTPRequest.pipe(takeUntil(this.destroy$)).subscribe({
				next: (res: any) => {
					if (!res.recordset) {
						alert('ישנה תקלת תקשורת, נסה שנית מאוחר יותר');
						return;
					}

					if (this.pageMode$.value === 'teudotForConfirm' && res.recordset.length) {
						this.hasUserChangeColumnInTeudaSQLTable = 'UserChange' in res.recordset[0];
					}

					this.AllOrdersBitzoimPerAgentSave = this.AllOrdersBitzoimPerAgent = res.recordset;

					const datesSet: Set<string> = new Set(this.AllOrdersBitzoimPerAgent.map(perAgent => perAgent.TeudaDate.slice(0, 10)));

					this.datesFilter = [...datesSet];

					if (!['reclamation', 'brands', 'brandsAdmin'].includes(this.pageMode$.value)) {
						this.handleMatchDoctypes();
					}
				},
				error: () => {
					alert('ישנה תקלת תקשורת, נסה שנית מאוחר יותר');
					history.back();
					return;
				},
			});

		switch (this.pageMode$.value) {
			case 'B2B':
				this.canSeePrices = this._ss.CustomerInformation.B2BCanSeePrices !== '1';
				callbackAfterSubscribing(this._ss.getB2BOrders());
				break;
			case 'B2BOnly':
				callbackAfterSubscribing(this._ss.getB2BOnlyOrders());
				break;
			case 'brands':
				callbackAfterSubscribing(this._ss.handleGetBrandTable());
				break;
			case 'brandsAdmin':
				callbackAfterSubscribing(this._ss.handleGetBrandAdminTable());
				break;
			case 'reclamation':
				callbackAfterSubscribing(this._ss.handleGetAllReclamationOrders());
				break;
			case 'teudotForConfirm':
				callbackAfterSubscribing(this._ss.getAllTeudotForAgentConfirm());
				break;

			default:
				//bizoimAzmanot
				callbackAfterSubscribing(this._ss.GetAllOrdersOneAgent());
				break;
		}
	}

	getInitialPageMode(): PageMode {
		const includes = (str: PossiblePaths) => location.pathname.includes(str);

		switch (true) {
			case includes('b2b-to-agent'):
				return 'B2B';
			case includes('b2b-only'):
				return 'B2BOnly';
			case includes('reclamation'):
				return 'reclamation';
			case includes('brands-admin'):
				return 'brandsAdmin';
			case includes('brands'):
				return 'brands';
			case includes('teudot-for-confirm'):
				return 'teudotForConfirm';

			default:
				return 'bizoimAzmanot';
		}
	}

	getPageTitle(page: PageMode) {
		switch (page) {
			case 'brands':
			case 'brandsAdmin':
				return 'ביצועים מותגים';
			case 'B2B':
			case 'B2BOnly':
				return 'ביצועים תעודות B2B';
			case 'reclamation':
				return 'תעודות רקלמציה';
			case 'teudotForConfirm':
				return 'תעודות לאישור';

			default:
				return 'ביצועים תעודות';
		}
	}

	getLastColumnTitle(page: PageMode) {
		switch (page) {
			case 'teudotForConfirm':
				return 'פעולות';

			default:
				return 'סמן';
		}
	}

	buildTotalTeuda(teudaArray) {
		const keys = ['TeudaQuantity', 'TeudaPackQuantity', 'TeudaBonusQuantity'];
		let startingObject: Record<string, number> = {
			TeudaQuantity: 0,
			TeudaPackQuantity: 0,
			TeudaBonusQuantity: 0,
		};
		if (this.canSeePrices) {
			keys.push('TeudaPrice', 'TeudaItemDiscount', 'TeudaItemNetPrice', 'TeudaTotalRow');
			startingObject = {
				...startingObject,
				TeudaPrice: 0,
				TeudaItemDiscount: 0,
				TeudaItemNetPrice: 0,
				TeudaTotalRow: 0,
			};
		}
		this.selectedTeudaTotals = teudaArray.reduce((acc, curr) => {
			for (const key of keys) {
				acc[key] += +(curr[key] || 0);
			}

			return acc;
		}, startingObject);
	}
}
